export default __webpack_public_path__ + "static/media/ZA.10c7a9b4.svg";